import {
  DESIGNATOR_ALPHABET,
  SUGGESTED_CAMPAIGN_DESIGNATOR_LENGTH,
} from "../constants.js";

export function generateCampaignDesignator() {
  if (window.crypto?.getRandomValues) {
    const random = new Uint32Array(SUGGESTED_CAMPAIGN_DESIGNATOR_LENGTH);
    window.crypto.getRandomValues(random);

    return Array.from(
      random,
      (value) => DESIGNATOR_ALPHABET[value % DESIGNATOR_ALPHABET.length]
    ).join("");
  }

  return Array.from({ length: SUGGESTED_CAMPAIGN_DESIGNATOR_LENGTH }, () => {
    const index = Math.floor(Math.random() * DESIGNATOR_ALPHABET.length);
    return DESIGNATOR_ALPHABET[index];
  }).join("");
}
